import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Uveri se da je Tailwind pravilno importovan
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Kreiranje root-a
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Poziv reportWebVitals ako je potrebno
reportWebVitals();
